import React from "react";
import { Row } from "reactstrap";
import "./HeaderComponent.css";

function HeaderComponent(props) {
  return (
    <div id="header_section" style={{}}>
      <div id="header_top_shadow"></div>
      <div id="header_bottom_shadow"> </div>
      <div id="header_text_2">
        <Row>
          <div className="justify-content-center text-center mx-5">
            <div id="header_title">{props.title}</div>
            <div id="header_sub_title" className="ml-2 ml-md-0">
              {props.date}
            </div>
            <div id="header_divider"></div>
            <div id="header_sub_title" className="ml-2 ml-md-0">
              <i className="solid  fas fa-map-marker mr-4"></i>
              {props.address}
            </div>
          </div>
        </Row>
      </div>
      <img
        src={props.image}
        alt="Girl in a jacket"
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </div>
  );
}

export default HeaderComponent;
